import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy /result/... (singular) — permanently redirect to /results/...
export const Route = createFileRoute("/result/$")({
  beforeLoad: ({ params }) => {
    const rest = (params as { "*": string })["*"] ?? "";
    throw redirect({ href: `/results/${rest}/`, statusCode: 301 });
  },
});
